<ng-container *transloco="let t">
    <div class="modal-header">
        {{ title }}
    </div>
    <div class="modal-body">
        {{ message }}
    </div>
    <div class="modal-footer">
        <button *ngIf="showCancel" type="button" class="btn btn-outline-primary" (click)="activeModal.dismiss()">
            {{ t('IDS_BUTTON_CANCEL') }}
        </button>
        <button type="button" class="btn btn-primary" (click)="activeModal.close()">
            {{ t('IDS_BUTTON_CONTINUE') }}
        </button>
    </div>
</ng-container>
